import { Pipe, PipeTransform } from '@angular/core';
import { IWatabiLightBooking } from "libraries/interfaces/watabilight/IWatabiLightBooking.interface";

@Pipe({
    name: 'hasOneQuote'
})

export class HasOneQuotePipe implements PipeTransform {
    public transform(booking: IWatabiLightBooking): boolean {
        if(!booking.quotes?.length){
            return true;
        }
        return booking?.quotes?.length === 1;
    }
}
